export default __webpack_public_path__ + "static/media/body-background.9e7d96f6.png";